module.exports = __webpack_public_path__ + "b7f667b212a15199956c95b98dd9d7e3.pdf";